import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Hook to track which issues have calendar events
 * Returns a map of issue_id -> event info
 */
export function useCalendarizedIssues(token) {
  const [calendarizedIssues, setCalendarizedIssues] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchCalendarizedIssues = useCallback(async () => {
    if (!token) return;
    
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/calendar-events/by-issues`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCalendarizedIssues(response.data.issue_events || {});
    } catch (err) {
      console.error('Error fetching calendarized issues:', err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchCalendarizedIssues();
  }, [fetchCalendarizedIssues]);

  const isCalendarized = useCallback((issueId) => {
    return !!calendarizedIssues[issueId];
  }, [calendarizedIssues]);

  const getCalendarEvents = useCallback((issueId) => {
    return calendarizedIssues[issueId] || [];
  }, [calendarizedIssues]);

  return {
    calendarizedIssues,
    isCalendarized,
    getCalendarEvents,
    loading,
    refresh: fetchCalendarizedIssues
  };
}

export default useCalendarizedIssues;
